<template>
  <div class="pageNew">
    <div class="pettitle">
      <div class="tit">宠物商城编辑</div>
      <div class="dec">
        <span v-if="petdetail.breedInfo"
          >分类:{{ petdetail.breedInfo.name }}</span
        >
        <span style="margin-left: 20px">颜色:{{ petdetail.petColor }}</span>
        <span style="margin-left: 20px">性别:{{ petdetail.petSex }}</span>
        <span style="margin-left: 20px" v-if="petdetail.petLevel"
          >门店售价:{{ petdetail.petLevel.price }}</span
        >
        <span style="margin-left: 20px">芯片号:{{ petdetail.epromNo }}</span>
        <span style="margin-left: 20px">脖圈号:{{ petdetail.insideNo }}</span>
        <span style="margin-left: 20px"
          >出生日期:{{ $public.FTime(petdetail.bronDate, "YYYY-MM-DD") }}</span
        >
        <span style="margin-left: 20px"
          >状态:
          <span v-if="petdetail.appShelves == 0">未上架</span>
          <span v-if="petdetail.appShelves == 1">上架</span>
          <span v-if="petdetail.appShelves == -1">下架</span>
        </span>
      </div>
    </div>

    <div class="editfrom">
      <div class="com">
        <div class="mr">宠物封面图:</div>
        <el-upload
          class="avatar-uploader"
          action="action"
          :show-file-list="false"
          :http-request="uploadImg"
        >
          <img v-if="petdetail.cover" :src="petdetail.cover" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="com">
        <div class="mr">轮播图:</div>
        <el-button size="small" @click="handleUploadClick">上传图片</el-button>
        <input
          type="file"
          ref="file"
          style="width: 0; height: 0"
          @change="changeFile"
        />
      </div>
      <div class="com">
        <div class="mr"></div>
        <el-table :data="bannerList" border style="flex: 0.6">
          <el-table-column label="排序" align="center" prop="order">
          </el-table-column>
          <el-table-column prop="url" label="图片" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 60px; height: 60px"
                :src="scope.row.url"
                :preview-src-list="[scope.row.url]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="center">
            <template slot-scope="scope">
              <el-input
                placeholder="请输入图片名称"
                v-model="scope.row.name"
                clearable
                size="small"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleSortChange(scope.$index, scope.row, 1)"
                type="text"
                size="small"
                >前移
              </el-button>
              <el-button
                @click="handleSortChange(scope.$index, scope.row, 2)"
                type="text"
                size="small"
                >后移
              </el-button>
              <el-button
                @click="handleDeleteClick(scope.$index)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="com">
        <div class="mr">视频:</div>
        <el-button size="small" @click="handleVideoClick">上传视频</el-button>
        <input
          type="file"
          ref="fileVideo"
          style="width: 0; height: 0"
          @change="changeVideoFile"
        />
      </div>
      <div class="com">
        <div class="mr"></div>
        <el-table :data="videoList" border style="flex: 0.6">
          <el-table-column label="排序" align="center" prop="order">
          </el-table-column>
          <el-table-column prop="url" label="视频" align="center">
            <template slot-scope="scope">
              <video
                style="width: 60px; height: 60px"
                :src="scope.row.url"
              ></video>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="center">
            <template slot-scope="scope">
              <el-input
                placeholder="请输入视频名称"
                v-model="scope.row.name"
                clearable
                size="small"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleVideoSortChange(scope.$index, scope.row, 1)"
                type="text"
                size="small"
                >前移</el-button
              >
              <el-button
                @click="handleVideoSortChange(scope.$index, scope.row, 2)"
                type="text"
                size="small"
                >后移</el-button
              >
              <el-button
                @click="handleVideoDeleteClick(scope.$index)"
                type="text"
                size="small"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="com">
        <div class="mr">宠物分享图:</div>
        <el-upload
          class="avatar-uploader"
          action="action"
          :show-file-list="false"
          :http-request="uploadshare"
        >
          <img
            v-if="petdetail.shareCover"
            :src="petdetail.shareCover"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="com">
        <div class="mr">详情图:</div>
        <div class="imgView">
          <div
            v-for="(item, index) in detailImgList"
            :key="index"
            class="imgItem"
          >
            <img
              alt=""
              :src="item"
              v-if="detailImgList.length > 0"
              style="border-radius: 6px"
            />
            <i
              class="el-icon-error closeBtn"
              v-if="detailImgList.length > 0"
              @click="handleDeleteImgClick(index)"
            ></i>
          </div>
          <i
            class="el-icon-plus avatar-uploader-icon"
            style="border: 1px dashed #d9d9d9; border-radius: 6px"
            @click="handleUploadDetailClick"
          ></i>
          <input
            type="file"
            ref="fileDetail"
            style="width: 0; height: 0"
            @change="changeDetailFile"
          />
        </div>
      </div>
      <div class="com">
        <div class="mr">宠物品级:</div>
        <el-select
          size="small"
          v-model="petdetail.petGrade"
          placeholder="请选择"
          value-key="_id"
          style="width: 150px"
        >
          <el-option
            v-for="item in petstart"
            :key="item._id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="com">
        <div class="mr">宠物简介:</div>
        <el-input
          size="small"
          style="width: 150px"
          v-model="petdetail.petDescribe"
          placeholder="请输入内容"
        >
        </el-input>
      </div>
      <div class="com">
        <div class="mr">特价宠物:</div>
        <el-radio-group v-model="petdetail.isSpecialOffer">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </div>
      <div class="com">
        <div class="mr">宠物标签:</div>
        <el-checkbox-group v-model="petlabelmodel">
          <el-checkbox
            v-for="label in petLabel"
            :label="label._id"
            :key="label._id"
            >{{ label.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- <div class="com">
				<div class="mr">线上销售价:</div>
				<el-input size='small' style="width: 150px;" v-model="petdetail.onlineSalePrice" placeholder="请输入内容">
				</el-input>
			</div> -->
      <div class="com">
        <div class="mr">线上划线价:</div>
        <el-input
          size="small"
          style="width: 150px"
          v-model="petdetail.onlineMarkingPrice"
          placeholder="请输入内容"
        >
        </el-input>
      </div>
      <div class="com">
        <div class="mr">订金价格:</div>
        <el-input
          size="small"
          style="width: 150px"
          v-model="petdetail.onlineBookPrice"
          placeholder="请输入内容"
        >
        </el-input>
      </div>
      <div class="com">
        <div class="mr">订金锁定:</div>
        <el-input
          size="small"
          style="width: 150px; vertical-align: middle"
          placeholder=""
          v-model="petdetail.bookLockMinutes"
        >
          <template slot="append">分钟</template>
        </el-input>
      </div>
      <div class="com">
        <div class="mr">配送方式:</div>
        <el-checkbox-group v-model="petWaymodel">
          <el-checkbox v-for="way in petWay" :label="way._id" :key="way._id">{{
            way.name
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="com" v-if="petdetail.giftDetail">
        <div class="mr">赠送礼包:</div>
        <el-button size="small" @click="addGiftBag(0)">添加礼包</el-button>
        <div
          v-if="petdetail.giftDetail.give.length != 0"
          style="margin-left: 10px; font-size: 16px; color: orangered"
        >
          {{ petdetail.giftDetail.give[0].online_gift_bag_name }}-{{
            petdetail.giftDetail.give[0].sku_name
          }}
        </div>
      </div>
      <div class="com">
        <div class="mr">搭配礼包:</div>
        <el-button size="small" @click="addGiftBag(1)">添加礼包</el-button>
      </div>
      <div class="com" v-if="petdetail.giftDetail">
        <div class="mr"></div>
        <el-table
          class="table"
          v-if="petdetail.giftDetail.collocation.length != 0"
          :data="petdetail.giftDetail.collocation"
          style="flex: 0.6"
          border
        >
          <el-table-column label="线上名称" align="center">
            <template slot-scope="scope">
              <el-input
                placeholder="请输入内容"
                v-model="scope.row.online_gift_bag_name"
                clearable
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="gift_bag_name" label="名称" align="center">
          </el-table-column>
          <el-table-column prop="sku_name" label="规格" align="center">
          </el-table-column>
          <el-table-column label="数量" prop="count" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="small" @click="deleteitem(scope.$index)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="pageRightBtn">
      <el-button @click="isBack" size="small">返回</el-button>
      <el-button type="warning" @click="onSubmit" size="small">提交</el-button>
    </div>
    <div v-if="dialogGiftbag">
      <dialoggiftbag
        @closeOn="dialogGiftbag = false"
        :addShopState.sync="dialogGiftbag"
        @submit="getgoods"
      >
      </dialoggiftbag>
    </div>
  </div>
</template>

<script>
import dialoggiftbag from "../dialog_giftbag.vue";
import { getPetDl, getPetType, setPet } from "../../../api/program.js";
import { uploadImg } from "../../../api/stockApi.js";
export default {
  components: {
    dialoggiftbag,
  },
  data() {
    return {
      petdetail: {}, //宠物详情
      imageUrl: "",
      petlabelmodel: [], //宠物标签
      petLabel: [], //宠物标签数据
      petWay: [], //配送方式数据
      petWaymodel: [], //配送方式
      petstart: [], //宠物品级
      dialogGiftbag: false,
      bannerList: [], //图片表格
      videoList: [], //视频表格
      detailImgList: [], //详情图
      bagType: 0, //0是赠送礼包  1是搭配礼包
    };
  },
  created() {
    this.getPetWay();
    this.getPetLabel();
    this.getPetstart();
    this.getPetDl(this.$route.query.id);
  },
  methods: {
    //获取详情
    getPetDl(id) {
      let params = {
        petId: id,
      };
      getPetDl(params).then((res) => {
        console.log("获取详情", res.data);
        if (res.code == 0) {
          this.petdetail = res.data;
          //轮播图
          this.bannerList = this.petdetail.bannerList;
          //视频
          this.videoList = this.petdetail.videoList;
          //详情
          this.detailImgList = this.petdetail.detailImgList;
          //宠物标签
          this.petlabelmodel = this.petdetail.petSpecificLabel.map((item) => {
            return item._id;
          });
          //配送方式
          this.petWaymodel = this.petdetail.petDistributionWay.map((item) => {
            return item._id;
          });
        }
      });
    },
    //上传详情图
    changeDetailFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext1 = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      var ext = ext1.toLowerCase();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util.uploadImg_dir(formData, { dir: "appImg" }).then((data) => {
          if (data.timestamp) {
            this.detailImgList.push(data.url);
          }
        });
      } else {
        this.$message({
          message: "只能上传jpg,jpeg,png格式的文件",
          type: "error",
        });
        return;
      }
      this.$refs.file.value = null;
    },
    //转移详情图
    handleUploadDetailClick() {
      this.$refs.fileDetail.click();
    },
    //删除对应图片
    handleDeleteImgClick(index) {
      this.detailImgList.splice(index, 1);
    },
    //删除视频
    handleVideoDeleteClick(index) {
      this.$confirm("是否删除当前视频？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let videoList = [...this.videoList];
          videoList.splice(index, 1);
          for (let i = 0; i < videoList.length; i++) {
            videoList[i].order = i;
          }
          this.videoList = videoList;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //视频排序
    handleVideoSortChange(index, row, type) {
      if (type == 1) {
        console.log("前移");
        if (index == 0) {
          this.$message({
            type: "error",
            message: "已是第一位",
          });
        } else {
          let videoList = [...this.videoList];
          let copy = this.videoList[index];
          videoList.splice(index, 1);
          videoList.splice(index - 1, 0, copy);
          for (let i = 0; i < videoList.length; i++) {
            videoList[i].order = i;
          }
          this.videoList = videoList;
        }
      } else {
        console.log("后移");
        if (index == this.videoList.length - 1) {
          this.$message({
            type: "error",
            message: "已是最后一位",
          });
        } else {
          let videoList = [...this.videoList];
          let copy = this.videoList[index];
          videoList.splice(index, 1);
          videoList.splice(index + 1, 0, copy);
          for (let i = 0; i < videoList.length; i++) {
            videoList[i].order = i;
          }
          this.videoList = videoList;
        }
      }
    },
    //转移触发轮播图上传按钮
    handleUploadClick() {
      this.$refs.file.click();
    },
    //转移视频
    handleVideoClick() {
      this.$refs.fileVideo.click();
    },
    //上传视频
    changeVideoFile(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      console.log(ext, formData);
      if (
        ext === "mp4" ||
        ext === "ogg" ||
        ext === "avi" ||
        ext === "wmv" ||
        ext === "rmvb" ||
        ext === "mov"
      ) {
        formData.append("video", e.target.files[0]);
        this.$util.uploadVideo(formData).then((data) => {
          console.log(data);
          if (data.timestamp) {
            let obj = {
              order: that.videoList.length,
              name: "",
              url: data.url,
            };
            that.videoList.push(obj);
          }
        });
      } else {
        this.$message({
          message: "只能上传mp4,ogg,avi,wmv,rmvb,mov格式的文件",
          type: "error",
        });
      }
    },
    //轮播图排序
    handleSortChange(index, row, type) {
      console.log(index, row);
      if (type == 1) {
        console.log("前移");
        if (index == 0) {
          this.$message({
            type: "error",
            message: "已是第一位",
          });
        } else {
          let bannerList = [...this.bannerList];
          let copy = this.bannerList[index];
          bannerList.splice(index, 1);
          bannerList.splice(index - 1, 0, copy);
          for (let i = 0; i < bannerList.length; i++) {
            bannerList[i].order = i;
          }
          this.bannerList = bannerList;
        }
      } else {
        console.log("后移");
        if (index == this.bannerList.length - 1) {
          this.$message({
            type: "error",
            message: "已是最后一位",
          });
        } else {
          let bannerList = [...this.bannerList];
          let copy = this.bannerList[index];
          bannerList.splice(index, 1);
          bannerList.splice(index + 1, 0, copy);
          for (let i = 0; i < bannerList.length; i++) {
            bannerList[i].order = i;
          }
          this.bannerList = bannerList;
        }
      }
    },
    //删除轮播图
    handleDeleteClick(index) {
      this.$confirm("是否删除当前图片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let bannerList = [...this.bannerList];
          bannerList.splice(index, 1);
          for (let i = 0; i < bannerList.length; i++) {
            bannerList[i].order = i;
          }
          this.bannerList = bannerList;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //上传轮播图
    changeFile(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      console.log(ext);
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util.uploadImg_dir(formData, { dir: "appImg" }).then((data) => {
          console.log(data);
          if (data.timestamp) {
            let obj = {
              order: that.bannerList.length,
              name: "",
              url: data.url,
            };
            that.bannerList.push(obj);
          }
        });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //上传头像
    uploadImg(item) {
      var formData = new FormData();
      formData.append("img", item.file);
      uploadImg(formData).then((res) => {
        if (res.code == 0) {
          this.petdetail.cover = res.data.url;
        }
      });
    },
    //上传分享图
    uploadshare(item) {
      var formData = new FormData();
      formData.append("img", item.file);
      uploadImg(formData).then((res) => {
        if (res.code == 0) {
          this.petdetail.shareCover = res.data.url;
        }
      });
    },

    //提交
    onSubmit() {
      console.log("提交", this.petdetail);
      this.petdetail.petSpecificLabel = [];
      this.petdetail.petDistributionWay = [];
      this.petLabel.forEach((item) => {
        if (
          this.petlabelmodel.findIndex((ele) => {
            return ele == item._id;
          }) != -1
        ) {
          this.petdetail.petSpecificLabel.push({
            _id: item._id,
            name: item.name,
            code: item.custom_code,
          });
        }
      });
      this.petWay.forEach((item) => {
        if (
          this.petWaymodel.findIndex((ele) => {
            return ele == item._id;
          }) != -1
        ) {
          this.petdetail.petDistributionWay.push({
            _id: item._id,
            name: item.name,
            code: item.custom_code,
          });
        }
      });
      //轮播图
      this.petdetail.bannerList = this.bannerList;
      //视频
      this.petdetail.videoList = this.videoList;
      //详情
      this.petdetail.detailImgList = this.detailImgList;
      console.log(this.petdetail);
      setPet(this.petdetail).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "设置成功",
          });
          this.$router.go(-1);
        }
      });
    },
    //返回
    isBack() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //获取物流方式
    getPetWay() {
      getPetType({
        type: "物流方式",
        class: "服务字典",
      }).then((res) => {
        if (res.code == 0) {
          console.log("物流方式", res.data.data);
          this.petWay = res.data.data;
        }
      });
    },
    //获取宠物标签
    getPetLabel() {
      getPetType({
        type: "标签",
        class: "宠物",
      }).then((res) => {
        if (res.code == 0) {
          this.petLabel = res.data.data;
        }
      });
    },
    //获取品级
    getPetstart() {
      getPetType({
        type: "品级",
        class: "宠物",
      }).then((res) => {
        if (res.code == 0) {
          this.petstart = res.data.data;
        }
      });
    },
    //打开礼包框
    addGiftBag(type) {
      this.dialogGiftbag = true;
      this.bagType = type;
    },
    //选中礼包
    getgoods(data) {
      console.log("选中数据", data);
      if (this.bagType == 0) {
        //赠送礼包
        this.petdetail.giftDetail.give[0] = {
          gift_bag_id: data.data.giftBagId,
          online_gift_bag_name: data.data.title,
          sku_id: data.skuitem.plan_id,
          sku_name: data.skuitem.name,
          count: 1,
        };
        console.log("赠送礼包", this.petdetail.giftDetail.give);
      } else {
        //搭配礼包
        this.petdetail.giftDetail.collocation.push({
          gift_bag_id: data.data.giftBagId,
          online_gift_bag_name: data.data.title,
          sku_id: data.skuitem.plan_id,
          sku_name: data.skuitem.name,
          count: 1,
        });
        console.log("搭配礼包", this.petdetail.giftDetail.collocation);
      }
    },
    //删除礼包
    deleteitem(index) {
      this.petdetail.giftDetail.collocation.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.pageNew {
  background: #fff;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: scroll;
  .pageRightBtn {
    height: 90px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .pettitle {
    background-color: #fff;
    padding: 10px;

    .tit {
      color: #2a2a2a;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 20px;
    }

    .dec {
      font-size: 16px;
      margin-top: 10px;
    }
  }

  .editfrom {
    margin-top: 10px;
    background-color: #fff;
    padding-top: 10px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 158px;
    height: 158px;
    line-height: 158px;
    text-align: center;
  }

  .avatar {
    width: 158px;
    height: 158px;
    display: block;
    object-fit: cover;
  }

  .footer {
    // background-color: #f5f5f5;
    position: fixed;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    left: 220px;
    right: 0;
    padding-left: 20px;
    z-index: 200;
  }

  .mr {
    width: 100px;
    margin-left: 20px;
  }

  .com {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .imgView {
    flex: 1;

    .imgItem {
      position: relative;
      width: 148px;
      height: 148px;
      margin-right: 20px;
      margin-bottom: 10px;
      float: left;

      img {
        width: 100%;
        height: 100%;
      }

      .closeBtn {
        display: block;
        color: red;
        position: absolute;
        top: -15px;
        right: -15px;
        font-size: 30px;
        z-index: 5;
      }
    }
  }
}
.page::-webkit-scrollbar {
  display: none;
}
</style>
